var _excluded = ["children", "size", "width", "loading", "disabled", "onClick"];

var _templateObject;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import * as React from 'react';
import { styled } from '@creditas-ui/system';
import { ifProp, ifNotProp, ignorePropsForwarding } from '@creditas-ui/utilities';
import { Box } from '@creditas-ui/layout';
import { ProgressCircle } from '@creditas-ui/progress-indicator';
import { pressedBase, focus, hover, disabled, loading, widths, sizes, base } from './ButtonPrimaryTextOnly.style';
import { useButton } from '../useButton';
var ButtonElement = styled(Box.withComponent('button', process.env.NODE_ENV === "production" ? {
  target: "eacszil0"
} : {
  target: "eacszil0",
  label: "ButtonElement"
}), {
  shouldForwardProp: ignorePropsForwarding('loading')
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", ";\n  ", ";\n\n  &:hover {\n    ", ";\n  }\n\n  &:focus {\n    ", ";\n    outline: 0;\n  }\n\n  div.ripple {\n    ", ";\n  }\n"])), base, sizes, ifNotProp({
  size: 'small'
}, widths), ifProp({
  loading: true
}, loading), ifProp({
  disabled: true
}, disabled), ifProp({
  disabled: false,
  loading: false
}, hover), ifProp({
  disabled: false,
  loading: false
}, focus), ifProp({
  disabled: false,
  loading: false
}, pressedBase));
var buttonToSpinnerSize = {
  small: 'xsmall',
  medium: 'small',
  large: 'medium'
};

var ButtonPrimaryTextOnly = _ref => {
  var {
    children,
    size = 'medium',
    width = 'flexible',
    loading = false,
    disabled = false,
    onClick
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var buttonRef = React.useRef(null);
  var {
    handleClick
  } = useButton({
    buttonRef,
    loading,
    disabled,
    onClick
  });
  return /*#__PURE__*/React.createElement(ButtonElement, _extends({
    ref: buttonRef
  }, props, {
    size: size,
    width: width,
    loading: loading,
    disabled: disabled,
    onClick: handleClick
  }), /*#__PURE__*/React.createElement("span", {
    className: "not-visible-when-loading"
  }, children), loading && /*#__PURE__*/React.createElement(ProgressCircle, {
    className: "spinner",
    accessibilityMessage: children,
    size: buttonToSpinnerSize[size]
  }));
};

export { ButtonPrimaryTextOnly };
//# sourceMappingURL=ButtonPrimaryTextOnly.js.map